import { render, staticRenderFns } from "./ParticipantBidderDetails.vue?vue&type=template&id=3dbe1477&scoped=true&"
import script from "./ParticipantBidderDetails.vue?vue&type=script&lang=js&"
export * from "./ParticipantBidderDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbe1477",
  null
  
)

export default component.exports